import React from 'react';
import styled from 'styled-components';
import { localizationService } from '@shared-services/localization-service';
import CloseButton from '../CloseButton';
import { Modal, Title } from '../Modal';
import XIcon from '../icons/XIcon';

const str = (key: string) =>
    localizationService.str(
        `ui.runtimessr.calbooking.confirmation.dryRun.${key}`
    );

interface BookingConfirmationDryRunProps {
    closeConfirmation: () => void;
}

const BookingConfirmationDryRun = ({
    closeConfirmation,
}: BookingConfirmationDryRunProps) => (
    <Modal data-auto='booking-confirmation-screen'>
        <CloseButton onClick={closeConfirmation} />
        <Header>
            <ErrorIcon>
                <XIcon />
            </ErrorIcon>
            <Title>{str('title')}</Title>
        </Header>
        <hr />
        <Note>{str('note')}</Note>
    </Modal>
);

const Header = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
`;

const Note = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    font-size: 16px;
    font-weight: 350;
`;

const ErrorIcon = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 58px;
    border-radius: 50%;
    background-color: #fae3e4;
    margin: 0 auto 16px auto;

    svg {
        width: 32px;
        height: 32px;
        stroke: #bc3834;
        stroke-width: 2;
        stroke-linecap: round;
        fill: none;
    }
`;

export default BookingConfirmationDryRun;
